module.exports = __webpack_public_path__ + "static/media/maf-54.a404d06d.png";